module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_11.35342b80.png";